module.exports = __webpack_public_path__ + "mdkt2018/img/head.759734d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/20/head.jpg
// module id = hmvm
// module chunks = 1